import {
  Box,
  Button,
  Paper,
  TextField,
  Typography,
  MenuItem,
  Snackbar,
} from "@mui/material";
import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "../../../styles.module.css";
import {
  ActionMsg,
  Breadcrumb,
  Cancel,
  CTSinput,
  HandleCloseSnackbar,
  useMessageHandler,
} from "../../reusableComponent/Reusables";
import SaveIcon from "@mui/icons-material/Save";
import { useDispatch, useSelector } from "react-redux";
import {
  addCylinderHoldingLimit,
  editDeleteCylinderHoldingLimit,
  getProductList,
  getCustomerList,
} from "../../../actions/actions";
import dayjs from "dayjs";

const CylHoldingLimitAdd = () => {
  const dispatch = useDispatch();
  const login_details = sessionStorage.getItem('loginUser');
  const userD = JSON.parse(login_details);
  const userInfo = userD.result.userInfo;
  const { handleSubmit } = useForm();
  const urlLocation = useLocation();
  //   const editInfo = urlLocation.state;
  //   const editData = editInfo && editInfo;
  const editInfo = urlLocation.state;
  const editData = editInfo && editInfo;
  const editid = editData ? editData.chl_id : null;
  const respMsgState = useSelector((state) => state.cly_holding_limit.message);

  const [data, setData] = useState({
    cust_name: editData ? editData.cust_name : "",
    prod_code: editData ? editData.prod_code : "",
    max_holding: editData ? editData.max_holding : "",
    prod_description: editData ? editData.prod_description : "",
  });

  const handleChange = ({ target }) => {
    const value = target.value;
    if (target.name === "prod_code") {
      const selectedProduct = product.find((p) => p.prod_code === value);
      setData({
        ...data,
        [target.name]: value,
        prod_description: selectedProduct
          ? selectedProduct.prod_description
          : "", // Add this
      });
    } else {
      setData({
        ...data,
        [target.name]: value,
      });
    }
    data[target.name] = target.value;
  };

  const onSubmit = (event) => {
    const cylHoldingLimitData = {
      ...data,
      changedUpdatedValue: "edit",
      chl_id: editid,
      modified_at: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      modified_by: editData ? userInfo.user_id : null,
      created_at: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      created_by: editData ? editData.created_by : userInfo.user_id,
      // company_id: editData ? editData.company_id : userInfo.company_id,
      // jd_po_id: editid,
      // jd_po_details: jd_po_details,
      // created_by: editData ? editData.created_by : userInfo.company_id,
      // created_at: editData ? editData.created_at : dateConversionOnEntryPage(new Date()),
      // modified_by: editData ? userInfo.company_id : null,
      // modified_at: dateConversionOnEntryPage(new Date()),
    };
    if (editData) {
      dispatch(editDeleteCylinderHoldingLimit(cylHoldingLimitData));
    } else {
      dispatch(addCylinderHoldingLimit(cylHoldingLimitData));
    }
  };

  /////////////////////

  const { product } = useSelector((state) => state.product);

  // const [selectedUnit, setSelectedUnit] = useState('');

  useEffect(() => {
    dispatch(getProductList({ page: 0, size: 10, searchKey: "" }));
  }, [dispatch]);

  ////////

  const { customer } = useSelector((state) => state.customer);

  // const [selectedUnit, setSelectedUnit] = useState('');

  useEffect(() => {
    dispatch(getCustomerList({ page: 0, size: 10, searchKey: "" }));
  }, [dispatch]);

  ///////////////////////////
  let navigate = useNavigate();

  const [successMessage, setSuccessMessage] = useState(null);

  const { shouldShowMsg, responseMessage } = useMessageHandler(
    null,
    navigate,
    setSuccessMessage,
    respMsgState
  );

  useEffect(() => { }, [shouldShowMsg, responseMessage]);



  return (
    <>
      <Paper className={`${styles.cts_page}`}>
        <Breadcrumb
          routeSegments={[{ name: "Cylinder Holding Limit Setting" }]}
        />
        <Box sx={{ display: "flex" }}>
          <Grid container spacing={2} sx={{ pt: 1.5, pb: 1.5 }}>
            <Grid item md={7} sm={6} xs={12}>
              <Box sx={{ display: "flex" }}>
                <Typography className={`${styles.add_form_title}`}>
                  {editData ? "Update" : "Create"} Cylinder Holding Limit
                  Setting Master
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Box className={`${styles.sm_form}`}>
          <form onSubmit={handleSubmit(onSubmit)} style={{ width: "50%" }}>
            <Grid container spacing={1} sx={{ mt: 0 }}>
              <Grid item xs={4} className={`${styles.grid_lable}`}>
                <Typography className={`${styles.cts_lable_sm}`}>
                  Customer Name :
                </Typography>
              </Grid>
              <Grid item xs={8} className={`${styles.grid_input}`}>
                {/* <CTSinput
                  size="small"
                  fullWidth
                  type="text"
                  onChange={handleChange}
                  name="cust_name"
                  value={data.cust_name}
                  sx={{ width: "50%" }}
                /> */}
                <TextField
                  select
                  size="small"
                  fullWidth
                  onChange={handleChange}
                  name="cust_name"
                  value={data.cust_name}
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    style: {
                      height: 30,
                      fontSize: 12,
                      backgroundColor: "white",
                    },
                  }}
                  SelectProps={{
                    MenuProps: { PaperProps: { style: { maxHeight: 200 } } },
                  }}
                >
                  {/* <MenuItem value="">
                    <em>Select a Customer</em>
                  </MenuItem> */}
                  {customer &&
                    customer.map((customer) => (
                      <MenuItem className={`${styles.cts_lable}`}
                        key={customer.cust_id}
                        value={customer.cust_name}
                      >
                        {customer.cust_name}
                      </MenuItem>
                    ))}
                </TextField>
              </Grid>
              <Grid item xs={4} className={`${styles.grid_lable}`}>
                <Typography className={`${styles.cts_lable_sm}`}>
                  Prod Code :
                </Typography>
              </Grid>
              <Grid item xs={8} className={`${styles.grid_input}`}>
                {/* <CTSinput
                  size="small"
                  fullWidth
                  type="text"
                  onChange={handleChange}
                  name="prod_code"
                  value={data.prod_code}
                  sx={{ width: "100%" }}
                /> */}
                <TextField
                  select
                  size="small"
                  fullWidth
                  onChange={handleChange}
                  name="prod_code"
                  value={data.prod_code}
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    style: {
                      height: 30,
                      fontSize: 12,
                      backgroundColor: "white",
                    },
                  }}
                  SelectProps={{
                    MenuProps: { PaperProps: { style: { maxHeight: 200 } } },
                  }}
                >
                  {/* <MenuItem value="">
                    <em>Select a Product Code</em>
                  </MenuItem> */}
                  {product &&
                    product.map((product) => (
                      <MenuItem key={product.prod_id} value={product.prod_code} className={`${styles.cts_lable}`}>
                        {product.prod_code}
                      </MenuItem>
                    ))}
                </TextField>
              </Grid>
              <Grid item xs={4} className={`${styles.grid_lable}`}>
                <Typography className={`${styles.cts_lable_sm}`}>
                  Product Description:
                </Typography>
              </Grid>
              <Grid item xs={8} className={`${styles.grid_input}`}>
                <TextField
                  size="small"
                  fullWidth
                  value={data.prod_description}
                  variant="outlined"
                  InputProps={{
                    readOnly: true,
                    style: {
                      height: 30,
                      fontSize: 12,
                      backgroundColor: "#f0f0f0",
                    },
                  }}
                />
              </Grid>
              <Grid item xs={4} className={`${styles.grid_lable}`}>
                <Typography className={`${styles.cts_lable_sm}`}>
                  Max Holding :
                </Typography>
              </Grid>
              <Grid item xs={8} className={`${styles.grid_input}`}>
                <CTSinput
                  size="small"
                  fullWidth
                  type="text"
                  onChange={handleChange}
                  name="max_holding"
                  value={data.max_holding}
                  sx={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={12} className={`${styles.grid_input}`}>
                <Box sx={{ marginTop: "12px", float: "right" }}>
                  <Button
                    color="primary"
                    id={`${styles.btn_save}`}
                    variant="contained"
                    type="submit"
                  >
                    <SaveIcon
                      style={{ fontSize: "16px", marginRight: "10px" }}
                    />{" "}
                    {editData ? "Update" : "Save"}
                  </Button>
                  <Cancel />
                </Box>
              </Grid>
            </Grid>
          </form>
        </Box>
        <Snackbar
          style={{ zIndex: 9998 }}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={successMessage ? true : false}
          autoHideDuration={2000}
          onClose={(event, reason) =>
            HandleCloseSnackbar(event, reason, setSuccessMessage)
          }
          message={successMessage}
          action={ActionMsg(setSuccessMessage)}
        />
      </Paper>
    </>
  );
};
export default CylHoldingLimitAdd;
